<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible="visible"
    width="1100px"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    destroy-on-close
    append-to-body
    v-el-dialog-drag
  >
    <EditForm
      ref="editForm"
      :shipmentCode="shipmentCode"
      :disabled="disabled"
      :data="data"
      @reload="$emit('reload')"
      @close="close()"
      @radioChange="radioChange"
    />
    <span slot="footer">
      <el-button size="small" @click="$refs.editForm.cancel()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        @click="$refs.editForm.append()"
        :disabled="btnDisabled"
      >
        {{ $l('INDEX.btn_append') || '追加' }}
      </el-button>
      <el-button
        type="success"
        size="small"
        v-if="!disabled"
        @click="$refs.editForm.save()"
        :disabled="!btnDisabled"
      >
        {{ $l('INDEX.btn_new') || '新建' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import EditForm from './index.vue'
export default {
  components: { EditForm },
  props: {
    title: { type: String, default: '' },
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    shipmentCode: { type: String, default: '' },
    data: { type: Object, default: () => {} },
  },
  data() {
    return {
      btnDisabled: true,
    }
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
    radioChange(data) {
      if (data) {
        this.btnDisabled = false
      } else {
        this.btnDisabled = true
      }
    },
  },
}
</script>

<style scoped></style>
